/* istanbul ignore file */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignalStream } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { getSignalStrength } from '../../../../../../utility/displayValueUtils';

const RssiDisplay = ({ rssi }) => (
  <div>
    <FontAwesomeIcon icon={faSignalStream} size="lg" style={{ color: 'white', marginRight: '0.2rem' }} />
    <span>{getSignalStrength(rssi)}</span>
  </div>
);

RssiDisplay.propTypes = {
  rssi: PropTypes.number.isRequired,
};
export default RssiDisplay;
